
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/reasons/create",
      function () {
        return require("private-next-pages/reasons/create.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/reasons/create"])
      });
    }
  